<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button (handleClick)="create()" class="!w-[150px]"> Create </app-primary-button>
  </div>

  <div class="list-section">
    <div class="delivery-tracking-materials-table flex flex-col gap-[40px]">
      @if (dataSource?.length) {
        <div class="materials-table">
          <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
            <ng-container matColumnDef="name">
              <th *matHeaderCellDef mat-header-cell>Name</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11 font-bold">{{ row?.name }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="uom">
              <th *matHeaderCellDef mat-header-cell>UOM</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.uom || '—' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="trackReceived">
              <th *matHeaderCellDef mat-header-cell>Track Received</th>
              <td *matCellDef="let row" mat-cell>
                <span
                  class="status-chip"
                  [ngClass]="row?.track_received ? 'bg-active txt-active' : 'bg-inactive txt-inactive'"
                >
                  {{ row?.track_received ? 'Yes' : 'No' }}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="trackUsed">
              <th *matHeaderCellDef mat-header-cell>Track Used</th>
              <td *matCellDef="let row" mat-cell>
                <span
                  class="status-chip"
                  [ngClass]="row?.track_used ? 'bg-active txt-active' : 'bg-inactive txt-inactive'"
                >
                  {{ row?.track_used ? 'Yes' : 'No' }}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="bidItems">
              <th *matHeaderCellDef mat-header-cell>Bid Items</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11 bid-items-cell">{{ getBidItemNames(row) }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th *matHeaderCellDef mat-header-cell></th>
              <td *matCellDef="let row" mat-cell>
                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editMaterial(row, $event)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="deleteMaterial(row, $event)">
                    <mat-icon svgIcon="trash"></mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              (click)="rowClicked(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              mat-row
            ></tr>
          </table>
        </div>
      }

      @if (!dataSource?.length) {
        <div class="no-data text-type-8 mt-[80px]">No data available.</div>
      }

      @if (totalRecords > 0) {
        <app-paginator
          (pageChanged)="onPageChanged($event)"
          [itemsPerPage]="pagination?.pageSize"
          [maxVisiblePages]="5"
          [totalItems]="totalRecords"
          class="paginator"
          />
      }
    </div>
  </div>
</div>
